import { StatsigClient } from '@statsig/js-client';
import { StatsigSessionReplayPlugin } from '@statsig/session-replay';
import { StatsigAutoCapturePlugin } from '@statsig/web-analytics';

// Initialize Statsig client with session replay and auto-capture
let statsigClient = null;

export const initializeStatsig = async () => {
  if (statsigClient) {
    return statsigClient;
  }

  const clientKey = process.env.REACT_APP_STATSIG_CLIENT_KEY || "client-Yjf1aRCBvLKzgOdnG9TUXLveivNumeZJDwD34cRBxNE";
  
  // Generate anonymous user ID
  const userID = `anonymous_${Math.random().toString(36).substr(2, 9)}`;

  try {
    statsigClient = new StatsigClient(
      clientKey,
      { userID },
      {
        environment: {
          tier: process.env.NODE_ENV === 'production' ? 'production' : 'staging'
        },
        plugins: [
          new StatsigSessionReplayPlugin({
            // Session replay configuration
            maskAllInputs: true,  // Mask sensitive inputs
            maskAllText: false,   // Don't mask regular text so you can see slop content
            captureScrollEvents: true,
            captureMouseEvents: true,
            captureClickEvents: true,
          }),
          new StatsigAutoCapturePlugin({
            // Auto-capture configuration
            capturePageViews: true,
            captureClicks: true,
            captureFormSubmissions: true,
          }),
        ],
      }
    );

    await statsigClient.initializeAsync();
    console.log('Statsig initialized successfully');
    return statsigClient;
  } catch (error) {
    console.error('Failed to initialize Statsig:', error);
    return null;
  }
};

export const getStatsigClient = () => {
  return statsigClient;
};

export const logEvent = (eventName, value = null, metadata = {}) => {
  if (statsigClient) {
    statsigClient.logEvent(eventName, value, metadata);
  }
};

// Helper function to log AI Slop Detector specific events
export const logSlopEvent = (eventType, data = {}) => {
  const eventName = `slop_detector_${eventType}`;
  logEvent(eventName, null, {
    timestamp: new Date().toISOString(),
    ...data
  });
};
